import { render } from "./articleCompile.vue?vue&type=template&id=36fd371c&scoped=true"
import script from "./articleCompile.vue?vue&type=script&lang=js"
export * from "./articleCompile.vue?vue&type=script&lang=js"

import "./css/antd.css?vue&type=style&index=0&lang=css"
import "./articleCompile.vue?vue&type=style&index=1&id=36fd371c&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fd371c"]])

export default __exports__